/**
 * Airport Shuttle Variant Handler
 * Manages shuttle selections in the person form and adds the selected variants to the cart
 */

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Initialize the shuttle selection functionality
   */
  // Make the function globally accessible so it can be called after person form re-renders
  window.initializeShuttleSelections = function() {
    console.log('Initializing shuttle selections');
    
    // Get shuttle data from hidden elements
    function getShuttleVariants(direction) {
      const dataElement = document.getElementById(`${direction}-shuttle-data`);
      if (!dataElement) {
        console.log(`No ${direction} shuttle data element found`);
        return [];
      }
      
      console.log(`${direction} shuttle product:`, dataElement.getAttribute('data-product-title'));
      console.log(`${direction} variants count:`, dataElement.getAttribute('data-variants-count'));
      
      const variants = [];
      const variantElements = dataElement.querySelectorAll('.shuttle-variant');
      
      variantElements.forEach(el => {
        variants.push({
          id: el.getAttribute('data-variant-id'),
          title: el.getAttribute('data-variant-title'),
          productId: el.getAttribute('data-product-id')
        });
      });
      
      console.log(`${direction} shuttle variants:`, variants);
      return variants;
    }
    
    // Get variants data
    const toFestivalVariants = getShuttleVariants('to');
    const fromFestivalVariants = getShuttleVariants('from');
    
    // Populate shuttle selects
    function populateShuttleSelects(selectClass, variants) {
      const selects = document.querySelectorAll(`.${selectClass}`);
      console.log(`Found ${selects.length} ${selectClass} selects`);
      
      if (variants.length === 0) {
        console.log(`No variants found for ${selectClass}`);
        return;
      }
      
      selects.forEach((select, i) => {
        console.log(`Populating ${selectClass} #${i+1} with ${variants.length} options`);
        
        // Clear existing options except the first one (No shuttle needed)
        while (select.options.length > 1) {
          select.remove(1);
        }
        
        variants.forEach(variant => {
          const option = document.createElement('option');
          option.value = variant.id;
          option.setAttribute('data-variant-id', variant.id);
          option.textContent = variant.title;
          select.appendChild(option);
        });
        
        console.log(`${selectClass} #${i+1} now has ${select.options.length} options`);
      });
    }
    
    // Populate both shuttle selects
    populateShuttleSelects('shuttle-to-festival-select', toFestivalVariants);
    populateShuttleSelects('shuttle-from-festival-select', fromFestivalVariants);
    
    // Original form submission handler
    const form = document.querySelector('form[action$="/cart/add"]');
    if (!form) {
      console.log('No form found');
      return;
    }
    
    // Track original form submission
    form.addEventListener('submit', async function(event) {
      console.log('Form submit triggered');
      
      // Check if any shuttles are selected
      const shuttleToggles = document.querySelectorAll('input[id^="shuttle-toggle-"]');
      const hasShuttleSelections = Array.from(shuttleToggles).some(toggle => toggle.checked);
      
      // If NO shuttles selected, let the normal product-form flow handle everything
      if (!hasShuttleSelections) {
        console.log('No shuttles selected - using normal product form submission');
        
        // DEBUG: Log all form data being submitted
        const debugFormData = new FormData(form);
        console.log('[DEBUG] Form data being submitted:');
        for (let [key, value] of debugFormData.entries()) {
          console.log(`  ${key}: ${value}`);
        }
        
        // Don't prevent default - let product-form handle it
        // Service fees will be added automatically via cart-insurance.js subscription
        return;
      }
      
      // ONLY intercept if shuttles are selected
      event.preventDefault();
      event.stopImmediatePropagation();
      console.log('Shuttles selected - intercepting to handle shuttle products separately');

      try {
        // Get all shuttle selections to handle separately
        const shuttleSelections = {};
        
        // Find all shuttle toggles and their corresponding selects
        shuttleToggles.forEach(toggle => {
          if (toggle.checked) {
            const personIndex = toggle.id.split('-').pop();
            
            const toFestivalSelect = document.querySelector(`select[name="properties[person_${personIndex}_to_festival_shuttle]"]`);
            const fromFestivalSelect = document.querySelector(`select[name="properties[person_${personIndex}_from_festival_shuttle]"]`);
            
            // Store the selections to handle after main product is added
            shuttleSelections[personIndex] = {
              to: toFestivalSelect && toFestivalSelect.value ? {
                value: toFestivalSelect.value,
                text: toFestivalSelect.options[toFestivalSelect.selectedIndex].textContent
              } : null,
              from: fromFestivalSelect && fromFestivalSelect.value ? {
                value: fromFestivalSelect.value,
                text: fromFestivalSelect.options[fromFestivalSelect.selectedIndex].textContent
              } : null,
              firstName: document.getElementById(`first-name-${personIndex}`)?.value || `Person ${personIndex}`,
              lastName: document.getElementById(`last-name-${personIndex}`)?.value || ''
            };
          }
        });
        
        // IMPORTANT: Replace shuttle variant IDs with human-readable text in form
        // This keeps the shuttle info in the main product's properties for workflow processing
        shuttleToggles.forEach(toggle => {
          const personIndex = toggle.id.split('-').pop();
          
          const toSelect = document.querySelector(`select[name="properties[person_${personIndex}_to_festival_shuttle]"]`);
          const fromSelect = document.querySelector(`select[name="properties[person_${personIndex}_from_festival_shuttle]"]`);
          
          // Replace select with hidden input containing the TEXT (not variant ID)
          if (toSelect && toSelect.value) {
            const selectedText = toSelect.options[toSelect.selectedIndex].textContent;
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = `properties[person_${personIndex}_to_festival_shuttle]`;
            hiddenInput.value = selectedText; // Store the TIME/TEXT, not variant ID
            toSelect.parentNode.insertBefore(hiddenInput, toSelect);
            toSelect.remove();
          } else if (toSelect) {
            toSelect.remove();
          }
          
          if (fromSelect && fromSelect.value) {
            const selectedText = fromSelect.options[fromSelect.selectedIndex].textContent;
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = `properties[person_${personIndex}_from_festival_shuttle]`;
            hiddenInput.value = selectedText; // Store the TIME/TEXT, not variant ID
            fromSelect.parentNode.insertBefore(hiddenInput, fromSelect);
            fromSelect.remove();
          } else if (fromSelect) {
            fromSelect.remove();
          }
        });
        
        // Now submit the main product using the NORMAL product-form flow
        console.log('Submitting main product via product-form...');
        
        // Trigger the product-form's add method directly
        if (window.theme?.cart?.store) {
          const formData = new FormData(form);
          const item = Object.fromEntries(formData.entries());
          
          // DEBUG: Log all form data being submitted
          console.log('[DEBUG] Form data with shuttle info preserved:');
          for (let [key, value] of formData.entries()) {
            console.log(`  ${key}: ${value}`);
          }
          console.log('[DEBUG] Item object:', item);
          
          await window.theme.cart.store.getState().add(item);
          console.log('Main product added successfully via cart store (with shuttle info in properties)');
          
          // Service fees are automatically handled by cart-insurance.js via subscription
          
          // Wait a bit for cart to settle
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // Add shuttle products if selected
          if (Object.keys(shuttleSelections).length > 0) {
            console.log('Adding shuttle selections:', shuttleSelections);
            await addShuttleSelections(shuttleSelections);
            
            // IMPORTANT: Refresh cart store to include shuttles
            console.log('Refreshing cart store to include shuttles...');
            const updatedCart = await fetch('/cart.js').then(r => r.json());
            
            // Use the same pattern as cart-store.js
            const { produce } = window.theme.cart.functions;
            window.theme.cart.store.setState(
              produce((draft) => {
                draft.products = updatedCart;
              })
            );
            
            // Trigger cart updated event for UI components
            document.dispatchEvent(new CustomEvent('cart:updated'));
            console.log('Cart store refreshed with shuttles');
          }
        } else {
          console.error('Cart store not available');
        }
        
        // Cart store handles UI updates automatically via subscriptions
        console.log('Cart updated successfully with shuttles');
        
        // Open cart drawer (product-form normally does this via notify-on-add)
        if (typeof theme?.mfpOpen === 'function') {
          theme.mfpOpen('cart');
        }
        
        // Refresh the page only if specifically requested
        // window.location.href = '/cart';
      } catch (error) {
        console.error('Error during cart submission:', error);
        // If there's an error, let user know
        alert('There was a problem adding items to your cart. Please try again.');
      }
    });
    
    // Create a summary container for selected shuttles
    let summaryContainer = document.createElement('div');
    summaryContainer.id = 'shuttle-summary';
    summaryContainer.style.margin = '1.5rem 0';
    summaryContainer.style.padding = '1rem';
    summaryContainer.style.border = '1px solid #e5e5e5';
    summaryContainer.style.borderRadius = '4px';
    summaryContainer.style.backgroundColor = '#f9f9f9';
    summaryContainer.style.display = 'none';
    
    // Insert before the add to cart button
    const addToCartBtn = form.querySelector('.product-form__add');
    if (addToCartBtn) {
      addToCartBtn.parentNode.insertBefore(summaryContainer, addToCartBtn);
    } else {
      form.appendChild(summaryContainer);
    }
    
    // Listen for changes on any shuttle toggle or select
    document.addEventListener('change', function(event) {
      if (event.target && 
         (event.target.id && event.target.id.startsWith('shuttle-toggle-')) || 
         (event.target.classList && (event.target.classList.contains('shuttle-to-festival-select') || 
                                     event.target.classList.contains('shuttle-from-festival-select')))) {
        updateShuttleSummary();
      }
    });
    
    // Update initial state
    updateShuttleSummary();
  }
  
  /**
   * Add shuttle selections to cart
   * @param {Object} shuttleSelections - Object with person indices as keys and selected shuttles as values
   */
  async function addShuttleSelections(shuttleSelections) {
    const shuttleItems = [];
    
    // Process all shuttle selections
    Object.entries(shuttleSelections).forEach(([personIndex, selections]) => {
      // Add to-festival shuttle if selected
      if (selections.to) {
        shuttleItems.push({
          id: selections.to.value,
          quantity: 1,
          properties: {
            'For': `${selections.firstName} ${selections.lastName}`,
            'Type': 'Airport to Festival Shuttle',
            '_shuttle_passenger': `${selections.firstName} ${selections.lastName}`,
            '_shuttle_type': 'to_festival'
          }
        });
      }
      
      // Add from-festival shuttle if selected
      if (selections.from) {
        shuttleItems.push({
          id: selections.from.value,
          quantity: 1,
          properties: {
            'For': `${selections.firstName} ${selections.lastName}`,
            'Type': 'Festival to Airport Shuttle',
            '_shuttle_passenger': `${selections.firstName} ${selections.lastName}`,
            '_shuttle_type': 'from_festival'
          }
        });
      }
    });
    
    // Add items to cart if any
    if (shuttleItems.length === 0) {
      console.log('No shuttle items to add');
      return null;
    }
    
    console.log('Adding shuttle items to cart:', shuttleItems);
    
    try {
      // Try adding all shuttles at once
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: shuttleItems })
      });
      
      if (!response.ok) {
        throw new Error(`Failed to add shuttles: ${await response.text()}`);
      }
      
      const result = await response.json();
      console.log('All shuttles added successfully:', result);
      return result;
      
    } catch (error) {
      console.error('Error adding shuttles:', error);
      
      // Fall back to adding one by one if bulk add fails
      console.log('Trying to add shuttles individually...');
      const results = [];
      
      for (const item of shuttleItems) {
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: [item] })
          });
          
          if (response.ok) {
            const result = await response.json();
            console.log('Shuttle added successfully:', result);
            results.push(result);
          } else {
            console.error('Failed to add shuttle:', await response.text());
          }
          
          // Small delay between requests
          await new Promise(resolve => setTimeout(resolve, 200));
          
        } catch (innerError) {
          console.error('Error adding individual shuttle:', innerError);
        }
      }
      
      return results.length > 0 ? results : null;
    }
  }
  
  /**
   * Update the shuttle summary display
   */
  function updateShuttleSummary() {
    const summaryContainer = document.getElementById('shuttle-summary');
    if (!summaryContainer) return;
    
    // Get all shuttle toggles and collect selected options
    const shuttleToggles = document.querySelectorAll('input[id^="shuttle-toggle-"]');
    const selectedToShuttles = [];
    const selectedFromShuttles = [];
    
    shuttleToggles.forEach(toggle => {
      if (toggle.checked) {
        const personIndex = toggle.id.split('-').pop();
        
        // Check if they selected to-festival shuttle
        const toFestivalSelect = document.querySelector(`select[name="properties[person_${personIndex}_to_festival_shuttle]"]`);
        if (toFestivalSelect && toFestivalSelect.value) {
          const option = toFestivalSelect.options[toFestivalSelect.selectedIndex];
          selectedToShuttles.push({
            person: personIndex,
            variant: option.value,
            title: option.textContent,
            firstName: document.getElementById(`first-name-${personIndex}`)?.value || `Person ${personIndex}`,
            lastName: document.getElementById(`last-name-${personIndex}`)?.value || ''
          });
        }
        
        // Check if they selected from-festival shuttle
        const fromFestivalSelect = document.querySelector(`select[name="properties[person_${personIndex}_from_festival_shuttle]"]`);
        if (fromFestivalSelect && fromFestivalSelect.value) {
          const option = fromFestivalSelect.options[fromFestivalSelect.selectedIndex];
          selectedFromShuttles.push({
            person: personIndex,
            variant: option.value,
            title: option.textContent,
            firstName: document.getElementById(`first-name-${personIndex}`)?.value || `Person ${personIndex}`,
            lastName: document.getElementById(`last-name-${personIndex}`)?.value || ''
          });
        }
      }
    });
    
    // Update summary content
    if (selectedToShuttles.length > 0 || selectedFromShuttles.length > 0) {
      let summaryHTML = `<h3 style="margin-top: 0; margin-bottom: 0.75rem;">Selected Airport Shuttles</h3>`;
      
      if (selectedToShuttles.length > 0) {
        summaryHTML += `<h4 style="margin-bottom: 0.5rem;">Airport to Festival:</h4>`;
        summaryHTML += `<ul style="margin-top: 0; padding-left: 1.25rem;">`;
        selectedToShuttles.forEach(shuttle => {
          summaryHTML += `<li>${shuttle.firstName} ${shuttle.lastName}: ${shuttle.title}</li>`;
        });
        summaryHTML += `</ul>`;
      }
      
      if (selectedFromShuttles.length > 0) {
        summaryHTML += `<h4 style="margin-bottom: 0.5rem;">Festival to Airport:</h4>`;
        summaryHTML += `<ul style="margin-top: 0; padding-left: 1.25rem;">`;
        selectedFromShuttles.forEach(shuttle => {
          summaryHTML += `<li>${shuttle.firstName} ${shuttle.lastName}: ${shuttle.title}</li>`;
        });
        summaryHTML += `</ul>`;
      }
      
      summaryHTML += `<p style="font-size: 0.9rem; color: #666; margin-top: 1rem; margin-bottom: 0;">Selected shuttles will be added to your cart with your ticket/accommodation purchase.</p>`;
      
      summaryContainer.innerHTML = summaryHTML;
      summaryContainer.style.display = 'block';
    } else {
      summaryContainer.style.display = 'none';
    }
  }
  
  // Check if we're on a product page that has person details
  // And make sure we're not on the cart page
  if (document.getElementById('person-details-container') && !window.location.pathname.includes('/cart')) {
    // Initialize shuttle selections when the script loads
    window.initializeShuttleSelections();
    
    // Create a custom event for when variant changes to trigger repopulation
    document.addEventListener('variant:changed', function() {
      window.initializeShuttleSelections();
    });
  }
});